import {
  decorateArtistDemoEventChatEvents,
  getArtistDemoEventChatMessages,
  getArtistDemoEventChatUnreadCounts,
} from './artistDemoEventChatData';

const STORAGE_KEY = 'casticart:artist-demo:v1';
const DEMO_EVENT_NAME = 'Casticart デモコンサート';
const PREVIEW_QUERY_KEY = 'artistDemoPreview';
const PREVIEW_SCENARIO_QUERY_KEY = 'artistDemoScenario';
const PREVIEW_PATH = '/artist/workspaces/event-operations/dashboard';
const DEMO_PROFILE_AI_LIMITS = Object.freeze({
  sourceBioMinChars: 40,
  sourceBioMaxChars: 500,
  bioSmallGroupMaxChars: 300,
  bioLargeGroupMaxChars: 120,
  generationGuidanceMaxChars: 300,
});
const DEMO_PROFILE_IMAGE_PATH = '/images/artist-demo/yumiko-gakudan-profile.jpg';
const DEMO_PROMO_IMAGE_PATH = '/images/artist-demo/yumiko-gakudan-promo.jpg';
const DEMO_FLYER_PATHS = Object.freeze({
  'demo-event-summer-concert': '/images/artist-demo/flyer-demo-concert.jpg',
  'demo-event-hotel-lounge': '/images/artist-demo/flyer-hotel-lounge.jpg',
  'demo-event-family-concert': '/images/artist-demo/flyer-family-concert.jpg',
});
const DEMO_FLYER_BACK_PATHS = Object.freeze({
  'demo-event-summer-concert': '/images/artist-demo/flyer-demo-concert-back.jpg',
});
const DEMO_CONTRACT_TERMS = Object.freeze({
  transfer_info: '月末締め・翌月末払い。請求申請の承認後、登録済みの本人名義口座へ振り込みます。振込手数料は主催者が負担します。',
  selected_options: ['event_chat', 'invoice_request'],
  additional_usage_clause: '主催者は、本公演の記録および広報を目的として、当日の写真・映像を公式Webサイト、SNS、次回公演の告知物に無償で掲載できます。商品化、広告出稿その他の二次利用を行う場合は、利用媒体・期間・対価を別途協議します。',
  cancel_policy: '主催者都合による出演取消しは、本番日の30日前から8日前までは出演料の50％、7日前以降は100％を補償します。天災地変、交通機関の大規模な運休その他当事者の合理的な支配を超える事由がある場合は、双方協議のうえ決定します。',
  remarks: '衣装は黒を基調とした演奏会用正装。譜面台・椅子は主催者が用意します。交通費は出演料に含みます。昼食と飲料は主催者が手配します。',
  contact: '090-1234-5678 / production@casticart-demo.test',
  clauses: [
    {
      id: 'demo-clause-confidentiality',
      key: null,
      kind: 'custom',
      title: '秘密保持',
      body: '各当事者は、本契約または公演準備を通じて知り得た相手方の非公知情報を、本契約の履行以外の目的に利用せず、相手方の事前承諾なく第三者へ開示しません。ただし、法令または公的機関の命令に基づく開示はこの限りではありません。',
      order: 0,
      can_edit: true,
      can_delete: true,
      can_reorder: true,
    },
    {
      id: 'demo-clause-consultation',
      key: null,
      kind: 'custom',
      title: '協議事項・合意管轄',
      body: '本契約に定めのない事項または解釈に疑義が生じた場合は、当事者間で誠実に協議して解決します。協議によっても解決しない場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。',
      order: 1,
      can_edit: true,
      can_delete: true,
      can_reorder: true,
    },
    {
      id: 'anti_social_forces:1',
      key: 'anti_social_forces',
      kind: 'system_required',
      title: '反社会的勢力の排除',
      body: [
        '1. 本契約の各当事者は、相手方に対し、現在および将来にわたり、自ら（法人その他の団体の場合は、その役員、実質的に経営を支配する者またはこれらに準ずる者を含みます。）が、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他これらに準ずる者（以下「反社会的勢力」といいます。）に該当しないことを表明し、保証します。',
        '2. 本契約の各当事者は、反社会的勢力が経営を支配し、または経営に実質的に関与する関係、反社会的勢力を利用する関係、反社会的勢力に資金等を提供し、または便宜を供与する関係その他社会的に非難されるべき関係を有しないことを表明し、保証します。',
        '3. 本契約の各当事者は、自らまたは第三者を利用して、暴力的な要求、法的な責任を超えた不当な要求、脅迫的な言動または暴力、風説の流布・偽計・威力による相手方の信用の毀損または業務の妨害その他これらに準ずる行為を行いません。',
        '4. 相手方が前各項のいずれかに違反した場合、他方当事者は、何らの催告を要することなく、本契約の全部または一部を解除できます。',
        '5. 前項により解除された当事者は、解除により生じた損害について相手方に請求できません。また、違反した当事者は、その違反により相手方に生じた損害を賠償します。',
      ].join('\n'),
      order: 2,
      policy_version: 1,
      can_edit: false,
      can_delete: false,
      can_reorder: false,
    },
  ],
});

export const ARTIST_DEMO_FIXED_NOW = '2026-07-01T12:00:00+09:00';
export const ARTIST_DEMO_ARTIST = Object.freeze({
  artistId: 'demo-artist-yumiko-gakudan',
  artistUuid: 'demo-artist-yumiko-gakudan',
  name: '楽団 弓子',
  nameEn: 'yumiko gakudan',
  email: 'yumiko.gakudan@example.com',
});

const DEMO_PARTS = Object.freeze([
  { id: 1, label: 'ヴァイオリン', value: 'violin', short_name: 'Vn.', sort_order: 10, deletable: false },
  { id: 2, label: 'ヴィオラ', value: 'viola', short_name: 'Va.', sort_order: 20, deletable: false },
  { id: 3, label: 'チェロ', value: 'cello', short_name: 'Vc.', sort_order: 30, deletable: false },
  { id: 4, label: 'ピアノ', value: 'piano', short_name: 'Pf.', sort_order: 40, deletable: false },
]);

const DEMO_GROUP_TAGS = Object.freeze([
  { id: 1, label: '室内楽', value: 'chamber-music', short_name: '室内楽', sort_order: 10, deletable: false },
  { id: 2, label: 'オーケストラ', value: 'orchestra', short_name: 'オケ', sort_order: 20, deletable: false },
  { id: 3, label: 'イベント演奏', value: 'event-performance', short_name: 'イベント', sort_order: 30, deletable: false },
]);

const DEMO_GENRES = Object.freeze([
  { id: 1, name: 'クラシック', sort_order: 10, deletable: false },
  { id: 2, name: '室内楽', sort_order: 20, deletable: false },
  { id: 3, name: 'オーケストラ', sort_order: 30, deletable: false },
]);

const DEMO_VENUE_GENRES = Object.freeze([
  { id: 1, name: 'コンサートホール' },
  { id: 2, name: '多目的ホール' },
  { id: 3, name: 'ホテル・宴会場' },
]);

function demoAssetUrl(path) {
  const base = typeof window !== 'undefined' ? window.location.origin : 'https://casticart.invalid';
  return new URL(path, base).toString();
}

export const ARTIST_DEMO_SCENARIOS = Object.freeze([
  { id: 'standard', label: '標準利用中', description: '今後のイベント、契約、未読チャットがある状態' },
  { id: 'new-user', label: '初回利用', description: 'プロフィールや初期設定が未完了の状態' },
  { id: 'action-required', label: '対応が必要', description: '回答期限間近のオファーと未読通知がある状態' },
  { id: 'billing', label: '公演終了・請求', description: '公演終了後の請求申請と追加請求を確認する状態' },
  { id: 'exception', label: '取消・例外', description: 'イベント中止、期限切れ、再提出依頼がある状態' },
  { id: 'empty', label: '0件表示', description: '各一覧に対象データがない状態' },
]);

const listeners = new Set();
const nativeDate = Date;
let demoDateInstalled = false;

function readStoredState() {
  if (typeof window === 'undefined') return { active: false, scenarioId: 'standard' };
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
    const scenarioId = ARTIST_DEMO_SCENARIOS.some((item) => item.id === parsed?.scenarioId)
      ? parsed.scenarioId
      : 'standard';
    return { active: parsed?.active === true, scenarioId };
  } catch {
    return { active: false, scenarioId: 'standard' };
  }
}

let state = readStoredState();

const ONBOARDING_STEP_KEYS = ['profile_photo', 'profile_basic', 'bank_info', 'promo_photo'];
function createOnboardingProgress() {
  return { dismissed: false, done: {} };
}
// 初回利用シナリオのオンボーディング進捗（デモ内のみ・メモリ保持）。
// 再読み込みで初期化され、初回モーダルが再度表示される。
let onboardingProgress = createOnboardingProgress();

function emitChange() {
  listeners.forEach((listener) => listener());
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('casticart:artist-demo-change', { detail: state }));
  }
}

function installDemoDate() {
  if (demoDateInstalled || typeof window === 'undefined') return;
  const fixedTimestamp = nativeDate.parse(ARTIST_DEMO_FIXED_NOW);
  class ArtistDemoDate extends nativeDate {
    constructor(...args) {
      super(...(args.length === 0 ? [fixedTimestamp] : args));
    }

    static now() {
      return fixedTimestamp;
    }
  }
  Object.defineProperty(ArtistDemoDate, 'name', { value: 'Date' });
  window.Date = ArtistDemoDate;
  demoDateInstalled = true;
}

function restoreNativeDate() {
  if (!demoDateInstalled) return;
  window.Date = nativeDate;
  demoDateInstalled = false;
}

if (state.active) installDemoDate();

export function isArtistDemoActive() {
  return state.active;
}

export function getArtistDemoState() {
  return state;
}

export function subscribeArtistDemo(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function startArtistDemo(scenarioId = 'standard') {
  const normalized = ARTIST_DEMO_SCENARIOS.some((item) => item.id === scenarioId)
    ? scenarioId
    : 'standard';
  state = { active: true, scenarioId: normalized };
  onboardingProgress = createOnboardingProgress();
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }
  installDemoDate();
  emitChange();
}

export function stopArtistDemo() {
  state = { active: false, scenarioId: 'standard' };
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }
  restoreNativeDate();
  emitChange();
}

export function buildArtistDemoPreviewUrl(scenarioId = 'standard', baseUrl) {
  const normalized = ARTIST_DEMO_SCENARIOS.some((item) => item.id === scenarioId)
    ? scenarioId
    : 'standard';
  const fallbackBase = typeof window !== 'undefined' ? window.location.origin : 'https://casticart.invalid';
  const url = new URL(PREVIEW_PATH, baseUrl || fallbackBase);
  url.searchParams.set(PREVIEW_QUERY_KEY, '1');
  url.searchParams.set(PREVIEW_SCENARIO_QUERY_KEY, normalized);
  return url.toString();
}

// プレビュー中に別タブへ遷移しても、遷移先が同じデモ状態を復元できるようにする。
// 通常利用時は入力URLをそのまま返し、認証済みユーザーの導線へ影響させない。
export function withArtistDemoPreviewContext(urlLike) {
  if (!urlLike || !state.active) return urlLike;

  const fallbackBase = typeof window !== 'undefined'
    ? window.location.origin
    : 'https://casticart.invalid';
  const url = new URL(urlLike, fallbackBase);
  url.searchParams.set(PREVIEW_QUERY_KEY, '1');
  url.searchParams.set(PREVIEW_SCENARIO_QUERY_KEY, state.scenarioId);

  const source = String(urlLike);
  return /^[a-z][a-z\d+.-]*:/i.test(source)
    ? url.toString()
    : `${url.pathname}${url.search}${url.hash}`;
}

export function initializeArtistDemoPreview(locationLike) {
  const location = locationLike || (typeof window !== 'undefined' ? window.location : null);
  if (!location) return false;
  const params = new URLSearchParams(location.search || '');
  if (params.get(PREVIEW_QUERY_KEY) !== '1') return false;
  startArtistDemo(params.get(PREVIEW_SCENARIO_QUERY_KEY) || 'standard');
  return true;
}

initializeArtistDemoPreview();

export function getArtistDemoIdentity() {
  const profilePicture = demoAssetUrl(DEMO_PROFILE_IMAGE_PATH);
  return {
    success: true,
    isLoggedIn: true,
    userType: 'artist',
    role: 'artist',
    id: ARTIST_DEMO_ARTIST.artistId,
    userId: ARTIST_DEMO_ARTIST.artistId,
    artistUserId: ARTIST_DEMO_ARTIST.artistId,
    artistUuid: ARTIST_DEMO_ARTIST.artistUuid,
    artistId: ARTIST_DEMO_ARTIST.artistId,
    artist_id: ARTIST_DEMO_ARTIST.artistId,
    name: ARTIST_DEMO_ARTIST.name,
    displayName: ARTIST_DEMO_ARTIST.name,
    name_en: ARTIST_DEMO_ARTIST.nameEn,
    email: ARTIST_DEMO_ARTIST.email,
    profile_picture: profilePicture,
    profile_picture_url: profilePicture,
    gender: 'female',
    account_type: 'solo',
    demo: true,
  };
}

function demoProfile(scenarioId) {
  const incomplete = scenarioId === 'new-user';
  const profilePicture = incomplete ? null : demoAssetUrl(DEMO_PROFILE_IMAGE_PATH);
  return {
    success: true,
    artist_id: ARTIST_DEMO_ARTIST.artistId,
    id: ARTIST_DEMO_ARTIST.artistId,
    name: ARTIST_DEMO_ARTIST.name,
    name_en: ARTIST_DEMO_ARTIST.nameEn,
    email: ARTIST_DEMO_ARTIST.email,
    account_type: 'solo',
    profile_picture: profilePicture,
    profile_picture_url: profilePicture,
    profile_one_liner: incomplete ? '' : '音楽と人をつなぐヴァイオリニスト',
    bio: incomplete ? '' : 'クラシックを中心に、室内楽やイベント演奏で活動しています。',
    career_timeline: incomplete ? [] : [
      { id: 'demo-career-1', year: 2014, month: 3, title: '音楽大学を卒業', description: 'ヴァイオリンを専攻' },
      { id: 'demo-career-2', year: 2019, month: 10, title: '室内楽公演に出演', description: '東京・横浜を中心に活動' },
      { id: 'demo-career-3', year: 2024, month: 5, title: '地域文化賞を受賞', description: 'アウトリーチ活動が評価されました' },
    ],
    gender: 'female',
    parts: [1],
    group_tags: [1, 3],
    birth_year: 1992,
    birth_month: 4,
    birth_day: 18,
    birth_year_hidden: false,
    main_activity_regions: ['東京都'],
    sub_activity_regions: ['神奈川県', '千葉県'],
    allow_day_trip: true,
    allow_overnight: true,
    instagram_url: 'https://example.com/yumiko-gakudan',
    x_url: 'https://example.com/yumiko-gakudan-x',
    website_url: 'https://example.com/yumiko-gakudan-portfolio',
    phone_number: '090-1234-5678',
    line_linked: true,
    line_user_id: 'demo-line-user-yumiko',
    line_opt_in: true,
    line_linked_at: '2026-06-01T10:00:00+09:00',
    line_linked_at_jst: '2026/06/01 10:00',
    created_at: '2026-06-01T10:00:00+09:00',
    is_registered: true,
    has_bank_info: !incomplete,
  };
}

function demoEvents(scenarioId) {
  if (scenarioId === 'empty' || scenarioId === 'new-user') return [];
  const makeEvent = ({ uuid, name, date, open, start, venueId, venue, prefecture, performanceType, cancelled = false, additionalDates = [] }) => ({
    event_uuid: uuid,
    id: uuid,
    name,
    event_name: name,
    event_date: date,
    open_time: open,
    start_time: start,
    venue_id: venueId,
    venue,
    venue_name: venue,
    prefecture,
    performance_type: performanceType,
    info_is_published: true,
    contract_status: 'agreed',
    contract_artist_status: 'agreed',
    contract_statuses: ['agreed'],
    has_contract: true,
    // 本番日以外の日程（リハーサル・下見など）。カレンダーで淡色チップとして表示される。
    additional_dates: Array.isArray(additionalDates) ? additionalDates : [],
    canceled_at: cancelled ? '2026-06-29T15:00:00+09:00' : null,
    cancel_reason: cancelled ? '主催者都合により中止となりました。' : null,
    flyer_front_url: DEMO_FLYER_PATHS[uuid] ? demoAssetUrl(DEMO_FLYER_PATHS[uuid]) : null,
    flyer_back_url: DEMO_FLYER_BACK_PATHS[uuid] ? demoAssetUrl(DEMO_FLYER_BACK_PATHS[uuid]) : null,
  });

  if (scenarioId === 'billing') {
    return [makeEvent({
      uuid: 'demo-event-finished-recital',
      name: '初夏のクラシックリサイタル',
      date: '2026-06-20',
      open: '18:30',
      start: '19:00',
      venueId: 'demo-venue-hall',
      venue: 'キャスティカート文化ホール',
      prefecture: '東京都',
      performanceType: '東京公演',
    })];
  }

  if (scenarioId === 'exception') {
    return [
      makeEvent({
        uuid: 'demo-event-cancelled',
        name: 'サマーガーデンコンサート',
        date: '2026-07-04',
        open: '17:30',
        start: '18:00',
        venueId: 'demo-venue-garden',
        venue: 'みどり野ガーデンホール',
        prefecture: '東京都',
        performanceType: '夕公演',
        cancelled: true,
      }),
      makeEvent({
        uuid: 'demo-event-rescheduled',
        name: 'サマーガーデンコンサート 振替公演',
        date: '2026-07-25',
        open: '17:30',
        start: '18:00',
        venueId: 'demo-venue-garden',
        venue: 'みどり野ガーデンホール',
        prefecture: '東京都',
        performanceType: '振替公演',
      }),
    ];
  }

  return [
    makeEvent({
      uuid: 'demo-event-summer-concert',
      name: DEMO_EVENT_NAME,
      date: '2026-07-04',
      open: '18:30',
      start: '19:00',
      venueId: 'demo-venue-hall',
      venue: 'キャスティカート文化ホール',
      prefecture: '東京都',
      performanceType: '東京公演',
      additionalDates: [
        { additional_date: '2026-07-02', additional_date_title: '会場下見・打合せ', start_time: '14:00:00', end_time: '15:30:00' },
        { additional_date: '2026-07-03', additional_date_title: 'ゲネプロ（通し稽古）', start_time: '15:00:00', end_time: '18:00:00' },
      ],
    }),
    makeEvent({
      uuid: 'demo-event-hotel-lounge',
      name: 'ベイサイド・ホテルラウンジ演奏',
      date: '2026-07-18',
      open: '16:30',
      start: '17:00',
      venueId: 'demo-venue-bayside',
      venue: 'ベイサイドホテル横浜',
      prefecture: '神奈川県',
      performanceType: 'ラウンジ公演',
      additionalDates: [
        { additional_date: '2026-07-17', additional_date_title: 'リハーサル', start_time: '19:00:00', end_time: '20:30:00' },
      ],
    }),
    makeEvent({
      uuid: 'demo-event-family-concert',
      name: '夏休みファミリーコンサート',
      date: '2026-08-09',
      open: '13:30',
      start: '14:00',
      venueId: 'demo-venue-civic',
      venue: 'さいたま市民音楽ホール',
      prefecture: '埼玉県',
      performanceType: '昼公演',
    }),
  ];
}

function filterDemoEvents(events, params) {
  const startDate = params?.get('startDate') || '';
  const endDate = params?.get('endDate') || '';
  const filtered = events.filter((event) => (
    (!startDate || event.event_date >= startDate) && (!endDate || event.event_date <= endDate)
  ));
  const limit = Number(params?.get('limit') || 0);
  return Number.isFinite(limit) && limit > 0 ? filtered.slice(0, limit) : filtered;
}

function demoOffers(scenarioId) {
  if (scenarioId === 'empty' || scenarioId === 'new-user' || scenarioId === 'billing') return [];
  const status = scenarioId === 'exception' ? 'expired' : scenarioId === 'standard' ? 'approved' : 'pending';
  const primaryEvent = demoEvents(scenarioId === 'exception' ? 'standard' : scenarioId)[0];
  const offers = [{
    id: 'demo-offer-summer-concert',
    hold_casting_id: 'demo-offer-summer-concert',
    hold_casting_artist_id: 'demo-offer-artist-yumiko',
    subject: `${DEMO_EVENT_NAME} 出演オファー`,
    message: 'デモ公演へのご出演をお願いします。',
    response_deadline: '2026-07-02T18:00:00+09:00',
    status,
    created_at: '2026-06-26T10:30:00+09:00',
    events: primaryEvent ? [{ ...primaryEvent, status }] : [],
  }];
  if (scenarioId === 'action-required') {
    offers.push({
      id: 'demo-offer-autumn-event',
      hold_casting_id: 'demo-offer-autumn-event',
      hold_casting_artist_id: 'demo-offer-artist-yumiko-autumn',
      subject: '秋の企業レセプション 出演オファー',
      message: 'ウェルカム演奏と歓談中のBGMをお願いします。',
      response_deadline: '2026-07-05T12:00:00+09:00',
      status: 'counterproposal',
      created_at: '2026-06-30T14:00:00+09:00',
      events: [{
        event_uuid: 'demo-event-autumn-reception',
        event_name: '秋の企業レセプション',
        name: '秋の企業レセプション',
        event_date: '2026-09-12',
        venue_name: '丸の内デモホテル',
        prefecture: '東京都',
        status: 'counterproposal',
      }],
    });
  }
  return offers;
}

function demoContracts(scenarioId) {
  if (scenarioId === 'empty' || scenarioId === 'new-user') return { success: true, contracts: [] };
  const billed = scenarioId === 'billing';
  const cancelled = scenarioId === 'exception';
  return {
    success: true,
    contracts: [{
      id: 'demo-contract-yumiko',
      contract_artist_id: 'demo-contract-artist-yumiko',
      contract_id: 'demo-contract-yumiko',
      status: cancelled ? 'cancelled' : billed ? 'agreed' : 'agreed',
      fee: 55000,
      event_end_reported_at: billed ? '2026-06-20T22:00:00+09:00' : null,
      invoice_confirmed: false,
      invoice_resubmission_requested: cancelled,
      events: demoEvents(billed ? 'billing' : 'standard'),
    }, ...(scenarioId === 'action-required' ? [{
      id: 'demo-contract-family-concert',
      contract_artist_id: 'demo-contract-artist-family',
      contract_id: 'demo-contract-family-concert',
      status: 'pending',
      fee: 66000,
      response_deadline: '2026-07-03T18:00:00+09:00',
      invoice_confirmed: false,
      events: demoEvents('standard').filter((event) => event.event_uuid === 'demo-event-family-concert'),
    }] : [])],
  };
}

function demoQuickTasks(scenarioId) {
  if (scenarioId === 'empty' || scenarioId === 'new-user' || scenarioId === 'billing') return [];
  const tasks = [{
    id: 'demo-task-program',
    taskId: 'demo-task-program',
    title: '当日配布プログラムの表記を確認',
    description: '氏名、肩書き、曲目に誤りがないか確認してください。',
    status: 'open',
    priority: 'normal',
    dueDate: '2026-07-03',
    requestedBy: '制作担当 佐藤',
    requestedByAdminId: 'demo-admin-sato',
  }];
  if (scenarioId === 'action-required') {
    tasks.unshift({
      id: 'demo-task-emergency-contact',
      taskId: 'demo-task-emergency-contact',
      title: '緊急連絡先を回答',
      description: '本番当日の連絡先を7月2日までに入力してください。',
      status: 'open',
      priority: 'high',
      dueDate: '2026-07-02',
      requestedBy: '運営担当 高橋',
      requestedByAdminId: 'demo-admin-takahashi',
    });
  }
  if (scenarioId === 'exception') {
    tasks[0] = {
      ...tasks[0],
      id: 'demo-task-reschedule-confirmation',
      taskId: 'demo-task-reschedule-confirmation',
      title: '振替公演の日程を確認',
      description: '中止公演の振替日程と会場をご確認ください。',
      dueDate: '2026-07-03',
      priority: 'high',
    };
  }
  return tasks;
}

function demoAnnouncements(scenarioId) {
  if (scenarioId === 'empty' || scenarioId === 'new-user') return [];
  return [
    {
      id: 91001,
      title: '7月公演の交通費精算について',
      body: '交通費は公演終了後、経理・報酬画面から内容をご確認ください。領収書が必要な場合はイベントチャットでご案内します。',
      status: 'published',
      popupEnabled: false,
      popupActive: false,
      viewerAcknowledged: true,
      publishedAt: '2026-06-30T16:00:00+09:00',
      primaryPublishedAt: '2026-06-30T16:00:00+09:00',
    },
    {
      id: 91002,
      title: '本番当日の連絡はイベントチャットをご利用ください',
      body: '会場到着後の連絡や当日の変更事項は、対象イベントのイベントチャットで共有されます。',
      status: 'published',
      popupEnabled: false,
      popupActive: false,
      viewerAcknowledged: false,
      publishedAt: '2026-06-27T11:30:00+09:00',
      primaryPublishedAt: '2026-06-27T11:30:00+09:00',
    },
  ];
}

function demoRewards(scenarioId) {
  if (scenarioId === 'new-user') return [];
  return [{
    id: 'demo-reward-recital',
    contract_artist_id: 'demo-contract-artist-yumiko',
    parent_contract_artist_id: 'demo-contract-artist-yumiko',
    status: 'billed',
    fee: 55000,
    payout_amount: 55000,
    invoice_confirmed: true,
    invoice_confirmed_at: '2026-06-25T15:20:00+09:00',
    payment_due_date: '2026-07-31',
    events: demoEvents('billing'),
  }, {
    id: 'demo-reward-additional',
    contract_artist_id: 'demo-contract-artist-yumiko-additional',
    parent_contract_artist_id: 'demo-contract-artist-yumiko',
    status: 'billed',
    fee: 8800,
    payout_amount: 8800,
    invoice_kind: 'additional',
    invoice_confirmed: true,
    invoice_confirmed_at: '2026-06-27T10:00:00+09:00',
    payment_due_date: '2026-07-31',
    events: demoEvents('billing'),
  }];
}

function demoPersonalMessages(unread) {
  if (!unread || unread <= 0) return [];
  const staff = (id, name, adminId, position, content, createdAt) => ({
    id,
    message_type: 'admin_message',
    message_format: 'text',
    content,
    created_at: createdAt,
    is_read: true,
    admin_user_id: adminId,
    admin_full_name: name,
    admin_nickname: name,
    admin_position: position,
    admin_department: 'キャスティカート事務局',
    is_nickname_allowed: false,
    reactions: [],
  });
  const mine = (id, content, createdAt) => ({
    id,
    message_type: 'artist_message',
    message_format: 'text',
    content,
    created_at: createdAt,
    is_read: true,
    reactions: [],
  });
  // 新しい順（DESC）で返す。個別チャットは column-reverse 表示のため最新が最下部に並ぶ。
  const thread = [
    staff('demo-msg-8', '制作担当 佐藤', 'demo-admin-sato', '制作担当', '当日配布プログラムの原稿をお送りしました。お名前と曲目の表記に誤りがないかご確認ください。', '2026-06-30T17:20:00+09:00'),
    staff('demo-msg-7', '運営担当 高橋', 'demo-admin-takahashi', '運営担当', '7/4 Casticart デモコンサートの香盤表を更新しました。当日の集合は17:00、リハーサルは17:30からです。', '2026-06-30T16:05:00+09:00'),
    staff('demo-msg-6', '制作担当 佐藤', 'demo-admin-sato', '制作担当', '交通費の精算方法についてのご案内です。公演終了後、経理・報酬画面から申請いただけます。', '2026-06-29T14:40:00+09:00'),
    mine('demo-msg-5', '承知しました。当日はどうぞよろしくお願いいたします。', '2026-06-28T10:15:00+09:00'),
    staff('demo-msg-4', '運営担当 高橋', 'demo-admin-takahashi', '運営担当', '会場は「キャスティカート文化ホール」です。楽屋は2階の楽屋Aをご利用ください。', '2026-06-27T18:30:00+09:00'),
    mine('demo-msg-3', 'ありがとうございます。当日を楽しみにしております。', '2026-06-26T12:10:00+09:00'),
    staff('demo-msg-2', '制作担当 佐藤', 'demo-admin-sato', '制作担当', '楽団 弓子さん、この度はCasticart デモコンサートへのご出演をありがとうございます。ご不明点はこちらのチャットへお気軽にご連絡ください。', '2026-06-26T11:00:00+09:00'),
    staff('demo-msg-1', 'タクティカート事務局', 'demo-admin-office', '事務局', 'タクティカートをご利用いただきありがとうございます。出演に関するご連絡はこちらのチャットで行います。', '2026-06-25T09:00:00+09:00'),
  ];
  // 未読件数（unread-count と同値）に合わせ、新しい管理者メッセージから既読フラグを外す。
  let remaining = unread;
  thread.forEach((message) => {
    if (message.message_type === 'admin_message' && remaining > 0) {
      message.is_read = false;
      remaining -= 1;
    }
  });
  return thread;
}

function demoOnboardingStatus(scenarioId) {
  const isNewUser = scenarioId === 'new-user';
  const doneMap = isNewUser
    ? onboardingProgress.done
    : { profile_photo: true, profile_basic: true, bank_info: true, promo_photo: true };
  const steps = ONBOARDING_STEP_KEYS.map((key) => ({
    key,
    done: Boolean(doneMap[key]),
    data: key === 'profile_photo' ? { requiresUpload: !doneMap.profile_photo } : {},
  }));
  const firstIncomplete = steps.find((step) => !step.done) || null;
  const allDone = steps.every((step) => step.done);
  const required = isNewUser && !onboardingProgress.dismissed && !allDone;
  const profile = demoProfile(scenarioId);
  if (isNewUser && doneMap.profile_photo) {
    const picture = demoAssetUrl(DEMO_PROFILE_IMAGE_PATH);
    profile.profile_picture = picture;
    profile.profile_picture_url = picture;
  }
  const bankInfo = doneMap.bank_info
    ? { bank_name: 'デモ銀行', bank_code: '0000', branch_name: 'デモ支店', branch_code: '001', account_type: '普通', account_number: '1234567', account_name: 'ガクダン ユミコ' }
    : {};
  return {
    success: true,
    required,
    flow: isNewUser ? 'initial_setup' : null,
    currentStep: required ? firstIncomplete : null,
    steps,
    profile,
    bankInfo,
    photoCount: doneMap.promo_photo ? 1 : 0,
  };
}

const DEMO_GROUP_THREAD_ID = 'demo-group-summer-concert';
const DEMO_GROUP_TITLE = 'Casticart デモコンサート 出演者グループ';
const DEMO_GROUP_ASSIGNEES = [
  { id: 'demo-admin-sato', admin_user_id: 'demo-admin-sato', full_name: '制作担当 佐藤', display_name: '制作担当 佐藤', position: '制作担当', department: 'キャスティカート事務局' },
  { id: 'demo-admin-takahashi', admin_user_id: 'demo-admin-takahashi', full_name: '運営担当 高橋', display_name: '運営担当 高橋', position: '運営担当', department: 'キャスティカート事務局' },
];
const DEMO_GROUP_ARTISTS = [
  { id: ARTIST_DEMO_ARTIST.artistId, artist_id: ARTIST_DEMO_ARTIST.artistId, name: ARTIST_DEMO_ARTIST.name, name_en: ARTIST_DEMO_ARTIST.nameEn, gender: 'female' },
  { id: 'demo-artist-chihiro', artist_id: 'demo-artist-chihiro', name: 'ピアノ 千尋', gender: 'female' },
];

// グループは「Casticart デモコンサート」に紐づくため、その公演を持つシナリオでのみ表示する。
function demoHasGroupChat(scenarioId) {
  return scenarioId === 'standard' || scenarioId === 'action-required';
}

function demoGroupUnread(scenarioId) {
  if (!demoHasGroupChat(scenarioId)) return 0;
  return scenarioId === 'action-required' ? 2 : 1;
}

function demoGroupMessages(scenarioId) {
  if (!demoHasGroupChat(scenarioId)) return [];
  const staff = (id, adminId, name, content, createdAt) => ({
    id,
    message_id: id,
    sender_type: 'admin',
    admin_user_id: adminId,
    admin_full_name: name,
    admin_display_name: name,
    message_format: 'text',
    content,
    created_at: createdAt,
    is_read: true,
    reactions: [],
  });
  const peer = (id, artistId, name, content, createdAt) => ({
    id,
    message_id: id,
    sender_type: 'artist',
    artist_user_id: artistId,
    artist_id: artistId,
    artist_name: name,
    message_format: 'text',
    content,
    created_at: createdAt,
    is_read: true,
    reactions: [],
  });
  const mine = (id, content, createdAt) => ({
    id,
    message_id: id,
    sender_type: 'artist',
    artist_user_id: ARTIST_DEMO_ARTIST.artistId,
    artist_id: ARTIST_DEMO_ARTIST.artistId,
    artist_name: ARTIST_DEMO_ARTIST.name,
    message_format: 'text',
    content,
    created_at: createdAt,
    is_read: true,
    reactions: [],
  });
  // 新しい順（DESC）。グループチャットも column-reverse 表示で最新が最下部に並ぶ。
  return [
    staff('demo-gmsg-6', 'demo-admin-takahashi', '運営担当 高橋', '当日は17:00にホール楽屋口へお集まりください。香盤表はノートに共有しています。', '2026-06-30T18:10:00+09:00'),
    mine('demo-gmsg-5', '承知しました。よろしくお願いいたします。', '2026-06-30T12:30:00+09:00'),
    peer('demo-gmsg-4', 'demo-artist-chihiro', 'ピアノ 千尋', 'リハーサルの並び順の希望を後ほど共有しますね。', '2026-06-29T20:15:00+09:00'),
    staff('demo-gmsg-3', 'demo-admin-sato', '制作担当 佐藤', '出演者の皆さま、当日の進行についてはこちらのグループでご連絡します。ご質問もお気軽にどうぞ。', '2026-06-29T11:00:00+09:00'),
    staff('demo-gmsg-2', 'demo-admin-sato', '制作担当 佐藤', '楽団 弓子さん、ピアノ 千尋さんをこのグループにご招待しました。', '2026-06-29T10:55:00+09:00'),
    staff('demo-gmsg-1', 'demo-admin-office', 'タクティカート事務局', 'Casticart デモコンサート 出演者グループを作成しました。', '2026-06-29T10:50:00+09:00'),
  ];
}

function demoGroupThreadsForList(scenarioId) {
  const messages = demoGroupMessages(scenarioId);
  if (!messages.length) return [];
  const latest = messages[0];
  return [{
    thread_id: DEMO_GROUP_THREAD_ID,
    title: DEMO_GROUP_TITLE,
    status: 'open',
    icon_file: null,
    unread_count: demoGroupUnread(scenarioId),
    latest_message_preview: latest.content,
    latest_message_at: latest.created_at,
    updated_at: latest.created_at,
    linked_event_name: 'Casticart デモコンサート',
    linked_event_flyer_front_url: demoAssetUrl(DEMO_FLYER_PATHS['demo-event-summer-concert']),
  }];
}

function demoGroupThreadDetail(scenarioId) {
  const base = demoGroupThreadsForList(scenarioId)[0];
  if (!base) return null;
  return { ...base, assignees: DEMO_GROUP_ASSIGNEES, artists: DEMO_GROUP_ARTISTS };
}

// --- ドリルダウン詳細（オファー / 本契約 / イベント）用のデモデータ ---
// 共演者・出演者・参加者パネルはすべてこの1組の正本データから導出する。
const DEMO_EVENT_CAST = Object.freeze({
  'demo-event-summer-concert': [
    { artist_id: ARTIST_DEMO_ARTIST.artistId, name: ARTIST_DEMO_ARTIST.name, part: 'ヴァイオリン', gender: 'female' },
    { artist_id: 'demo-artist-chihiro', name: 'ピアノ 千尋', part: 'ピアノ', gender: 'female' },
  ],
});

const DEMO_EVENT_DETAIL_OVERRIDES = Object.freeze({
  'demo-event-summer-concert': {
    genre: 'クラシック',
    event_overview: 'クラシックの名曲を集めたデモ公演です。',
    program: 'モーツァルト/アイネ・クライネ・ナハトムジーク ほか',
    organizer: 'タクティカート',
  },
});

const DEMO_EVENT_STAFF = DEMO_GROUP_ASSIGNEES.map((assignee) => ({
  admin_user_id: assignee.admin_user_id,
  display_name: assignee.display_name,
  full_name: assignee.full_name,
}));

// 出演者が定義されていないイベントでも、視聴者本人は自身の公演に参加している。
function demoEventCastList(eventId) {
  return DEMO_EVENT_CAST[eventId] || [
    { artist_id: ARTIST_DEMO_ARTIST.artistId, name: ARTIST_DEMO_ARTIST.name, part: 'ヴァイオリン', gender: 'female' },
  ];
}

// イベント情報「出演者」行およびオファーカードの castSummary が読む形。
function demoEventCasts(eventId) {
  return demoEventCastList(eventId).map((cast, index) => ({
    id: `${eventId}-cast-${index}`,
    artist_id: cast.artist_id,
    artist_name: cast.name,
    cast_name: cast.name,
    cast_role: cast.part,
  }));
}

// /casting-info と /casting-progress で同一のパートIDを共有し、参加者パネルの割当を成立させる。
function demoEventCastingInfo(eventId) {
  const partIds = new Map();
  demoEventCastList(eventId).forEach((cast) => {
    if (!partIds.has(cast.part)) {
      partIds.set(cast.part, `${eventId}-part-${partIds.size}`);
    }
  });
  return Array.from(partIds.entries()).map(([part, id], index) => ({
    id,
    part,
    sort_order: index + 1,
  }));
}

function demoEventCastingProgress(eventId) {
  const infoByPart = new Map(demoEventCastingInfo(eventId).map((info) => [info.part, info.id]));
  return demoEventCastList(eventId).map((cast) => ({
    artist_id: cast.artist_id,
    artist_name: cast.name,
    artist_name_en: '',
    artist_profile_picture: '',
    artist_gender: cast.gender || '',
    casting_info_id: infoByPart.get(cast.part) || null,
    contract_status: 'agreed',
    is_chief: false,
    is_concertmaster: false,
    custom_roles: [],
    artist_parts: [],
    contract_updated_at: '2026-06-27T10:00:00+09:00',
  }));
}

// 単一イベント詳細を「イベント情報」サブパネルが埋まる形へ拡充する。
function enrichDemoEventDetail(event) {
  if (!event) return null;
  const overrides = DEMO_EVENT_DETAIL_OVERRIDES[event.event_uuid] || {};
  return {
    ...event,
    genre: overrides.genre || event.genre || 'クラシック',
    event_overview: overrides.event_overview ?? event.event_overview ?? '',
    program: overrides.program ?? event.program ?? '',
    organizer: overrides.organizer ?? event.organizer ?? 'タクティカート',
    operator: event.operator ?? '',
    casts: demoEventCasts(event.event_uuid),
    assigned_admins: DEMO_EVENT_STAFF,
    // 参加者パネル（共演者一覧）を表示するために公開フラグを立てる。
    members_visible_to_artists: true,
    selected_options: Array.isArray(event.selected_options) ? event.selected_options : [],
  };
}

function findDemoEvent(eventId) {
  return demoEvents('standard').find((event) => event.event_uuid === eventId) || null;
}

// --- イベント詳細ページの任意サブセクション（対象は summer-concert のみ）---
// これらのサブパネルは「データが空なら非表示」になるため、デモデータで埋めて表示させる。

const DEMO_TIMETABLE_ID = 9001;

// GET /api/events/:eventUuid/timetables/shared （香盤表パネルが読む形）。
// 列は既定（時刻/所要時間/進行・曲目）を使うため rows のみ与える。
function demoSharedTimetables(eventId) {
  if (eventId !== 'demo-event-summer-concert') return [];
  const row = (id, startTime, duration, item) => ({
    id,
    startTime,
    duration,
    item,
    rowType: 'normal',
    rowColor: '',
    rowTextColor: '',
    cells: {},
  });
  return [{
    id: DEMO_TIMETABLE_ID,
    title: '本番当日の進行',
    target_date: '2026-07-04',
    sort_order: 1,
    note: '',
    data: {
      rows: [
        row('demo-tt-row-1', '15:00', '30分', '会場入り・楽屋'),
        row('demo-tt-row-2', '15:30', '3時間', '音出し・リハーサル'),
        row('demo-tt-row-3', '18:30', '30分', '開場'),
        row('demo-tt-row-4', '19:00', '1時間30分', '本番開始'),
        row('demo-tt-row-5', '20:30', '30分', '終演'),
        row('demo-tt-row-6', '21:00', '', '撤収'),
      ],
    },
  }];
}

// GET /api/artist/events/:eventUuid/stage-seating/shared （共有シーティングパネルが読む形）。
// イベント詳細のパネルは一覧（タイトル/副題/編集可否/配置人数）だけを描画するため、
// 座席グリッドは持たず placements の件数のみが表示に使われる。can_edit:false で「プレビュー」導線になる。
function demoSharedStageSeating(eventId) {
  if (eventId !== 'demo-event-summer-concert') {
    return { success: true, layouts: [], shares: [] };
  }
  const placements = [
    { artist_id: 'demo-artist-yumiko-gakudan', x: 38, y: 58, locked: false, part_key: 'ヴァイオリン' },
    { artist_id: 'demo-artist-chihiro', x: 62, y: 58, locked: false, part_key: 'ピアノ' },
  ];
  return {
    success: true,
    event: { event_uuid: eventId, name: DEMO_EVENT_NAME },
    performances: [],
    participants: demoEventCastList(eventId).map((cast) => ({
      artist_id: cast.artist_id,
      name: cast.name,
      part_key: cast.part,
    })),
    layouts: [{
      id: 8001,
      title: '本番ステージ配置',
      group_label: '本番',
      event_performance_id: null,
      performance_name: '',
      can_edit: false,
      movable_part_keys: [],
      share_targets: [],
      // アーティスト向けエンドポイントは layout_data.placements を top-level placements にも複製する。
      layout_data: { placements },
      placements,
    }],
    shares: [],
  };
}

// GET /api/artist/events/:eventUuid/guest-tickets （取り置き・招待枠ダッシュボード）。
// イベント詳細から直接は開けない別ルートページだが、デモ内で開いても破綻しないよう実データ形で返す。
function demoGuestTicketDashboard(eventId) {
  const allocationId = 'demo-guest-alloc-summer';
  const registration = (id, guestName, guestNameKana, phone, relationship) => ({
    registrationId: id,
    eventUuid: eventId,
    allocationId,
    inviterArtistId: ARTIST_DEMO_ARTIST.artistId,
    inviterArtistName: ARTIST_DEMO_ARTIST.name,
    ticketTypeId: 1,
    ticketTypeName: '一般席',
    ticketPrice: null,
    eventPerformanceId: null,
    performanceName: null,
    kind: 'hold',
    status: 'reserved',
    guestName,
    guestNameKana,
    phone,
    email: null,
    relationship,
    affiliation: null,
    seatNote: null,
    accessibilityNote: null,
    registrationNote: null,
    internalNote: null,
    paidAmount: null,
    ticketSalesEntryId: null,
    createdAt: '2026-06-28T10:00:00+09:00',
    updatedAt: '2026-06-28T10:00:00+09:00',
  });
  const formField = (key, enabled, required) => ({ key, enabled, required });
  return {
    event: { event_uuid: eventId, name: DEMO_EVENT_NAME },
    settings: {
      eventUuid: eventId,
      registrationDeadlineAt: '2026-07-03T18:00:00+09:00',
      formFields: [
        formField('guestName', true, true),
        formField('guestNameKana', true, false),
        formField('phone', true, false),
        formField('email', false, false),
        formField('relationship', true, false),
        formField('affiliation', false, false),
        formField('seatNote', false, false),
        formField('accessibilityNote', false, false),
        formField('registrationNote', false, false),
      ],
      defaultHoldLimit: 4,
      defaultInviteLimit: 0,
      allParticipantsEnabled: true,
      updatedAt: '2026-06-27T10:00:00+09:00',
    },
    allocations: [{
      allocationId,
      eventUuid: eventId,
      artistId: ARTIST_DEMO_ARTIST.artistId,
      artistName: ARTIST_DEMO_ARTIST.name,
      ticketTypeId: 1,
      ticketTypeName: '一般席',
      eventPerformanceId: null,
      performanceName: null,
      holdLimit: 4,
      inviteLimit: 0,
      holdUsed: 2,
      inviteUsed: 0,
      registrationDeadlineAt: '2026-07-03T18:00:00+09:00',
      enabled: true,
      allocationSource: 'individual',
      updatedAt: '2026-06-27T10:00:00+09:00',
    }],
    registrations: [
      registration('demo-guest-reg-1', '山田 花子', 'ヤマダ ハナコ', '090-1234-5678', '友人'),
      registration('demo-guest-reg-2', '佐々木 健', 'ササキ ケン', '090-8765-4321', '知人'),
    ],
    summary: {
      capacity: 800,
      sold: 120,
      unpaidHolds: 2,
      invites: 0,
      paidHolds: 0,
      occupied: 122,
      remaining: 678,
      ticketTypes: [{
        ticketTypeId: 1,
        ticketTypeName: '一般席',
        eventPerformanceId: null,
        performanceName: null,
        capacity: 800,
        sold: 120,
        unpaidHolds: 2,
        invites: 0,
        paidHolds: 0,
        occupied: 122,
        remaining: 678,
      }],
    },
  };
}

// GET /api/artist/offer-details/:holdCastingId
function demoOfferDetail(scenarioId, holdCastingId) {
  if (holdCastingId === 'demo-offer-autumn-event') {
    const autumnEvent = {
      event_uuid: 'demo-event-autumn-reception',
      id: 'demo-event-autumn-reception',
      name: '秋の企業レセプション',
      event_name: '秋の企業レセプション',
      performance_type: '東京公演',
      event_date: '2026-09-12',
      open_time: '18:00',
      start_time: '18:30',
      venue_id: null,
      venue: '丸の内デモホテル',
      venue_name: '丸の内デモホテル',
      prefecture: '東京都',
      genre: 'クラシック',
      program: 'ウェルカム演奏、歓談中のBGM',
      organizer: 'タクティカート',
      operator: '',
      casts: demoEventCasts('demo-event-autumn-reception'),
      dates: [{ hold_date: '2026-09-12', note: '本番', hold_casting_id: holdCastingId, event_uuid: 'demo-event-autumn-reception' }],
      status: 'counterproposal',
      flyer_front_url: null,
    };
    return {
      id: holdCastingId,
      hold_casting_id: holdCastingId,
      base_event_uuid: 'demo-event-autumn-reception',
      subject: '秋の企業レセプション 出演オファー',
      message: 'ウェルカム演奏と歓談中のBGMをお願いします。',
      individual_message: '弓子さんの柔らかな音色が会場の雰囲気に合うと思い、お声がけしました。ウェルカム演奏では、クラシックを中心に親しみやすい曲も織り交ぜていただけるとうれしいです。',
      created_at: '2026-06-30T14:00:00+09:00',
      response_deadline: '2026-07-05T12:00:00+09:00',
      fee: 60000,
      is_multiple_events: false,
      is_all_events_required: false,
      sent_admin_name: '制作担当 佐藤',
      sent_admin_profile_picture: null,
      status: 'counterproposal',
      events: [autumnEvent],
    };
  }

  const status = scenarioId === 'exception' ? 'expired' : scenarioId === 'standard' ? 'approved' : 'pending';
  const event = {
    ...enrichDemoEventDetail(findDemoEvent('demo-event-summer-concert')),
    dates: [{ hold_date: '2026-07-04', note: '本番', hold_casting_id: holdCastingId, event_uuid: 'demo-event-summer-concert' }],
    status,
  };
  return {
    id: holdCastingId,
    hold_casting_id: holdCastingId,
    base_event_uuid: 'demo-event-summer-concert',
    subject: `${DEMO_EVENT_NAME} 出演オファー`,
    message: 'デモ公演へのご出演をお願いします。',
    individual_message: '弓子さんには第1ヴァイオリンをお願いしたく、ご連絡しました。以前ご一緒した公演での丁寧なアンサンブルが印象に残っており、今回もぜひご参加いただければうれしいです。',
    created_at: '2026-06-26T10:30:00+09:00',
    response_deadline: '2026-07-02T18:00:00+09:00',
    fee: 55000,
    is_multiple_events: false,
    is_all_events_required: false,
    sent_admin_name: '制作担当 佐藤',
    sent_admin_profile_picture: null,
    status,
    events: [event],
  };
}

// GET /api/artist/contract-detail/:contractArtistId （レスポンスは { data } でラップして返す）
function demoContractDetail(scenarioId, contractArtistId) {
  if (String(contractArtistId).includes('family')) {
    const familyEvent = enrichDemoEventDetail(findDemoEvent('demo-event-family-concert'));
    return {
      contract: {
        ...DEMO_CONTRACT_TERMS,
        event_uuid: 'demo-event-family-concert',
        event_venue: 'さいたま市民音楽ホール',
        reward_scheme: 'fixed',
        billing_open_reason: '',
        contract_type: 'performance_contract',
        request_memo: '夏休みファミリーコンサートのオーケストラ奏者として、本番および前日リハーサルへのご出演をお願いします。集合時刻、舞台動線、持ち物はイベントチャットで共有します。',
        is_multi: false,
        contact_person: '制作担当 佐藤',
      },
      contractArtist: {
        contract_artist_id: 'demo-contract-artist-family',
        status: 'pending',
        fee: 66000,
        response_deadline: '2026-07-03T18:00:00+09:00',
        payment_item_label: '出演料',
        withholding_required: true,
        event_cancel_amount: null,
        invoice_confirmed: false,
        invoice_resubmission_requested: false,
        supplemental_invoices: [],
        additional_rewards: [],
        invoice_registered_at_contract: true,
        artist_name: ARTIST_DEMO_ARTIST.name,
      },
      event: familyEvent,
      events: [familyEvent],
      schedule: [
        { id: 'demo-sched-family-rehearsal', event_uuid: 'demo-event-family-concert', schedule_date: '2026-08-08', start_time: '14:00', end_time: '17:00', note: '前日リハーサル', place_name: 'さいたま市民音楽ホール 第2練習室', place_address: '埼玉県さいたま市浦和区仲町2-10-22' },
        { id: 'demo-sched-family-soundcheck', event_uuid: 'demo-event-family-concert', schedule_date: '2026-08-09', start_time: '10:30', end_time: '12:00', note: 'サウンドチェック・ゲネプロ', place_name: 'さいたま市民音楽ホール', place_address: '埼玉県さいたま市浦和区仲町2-10-22' },
        { id: 'demo-sched-family-main', event_uuid: 'demo-event-family-concert', schedule_date: '2026-08-09', start_time: '14:00', end_time: '16:00', note: '本番', place_name: 'さいたま市民音楽ホール', place_address: '埼玉県さいたま市浦和区仲町2-10-22' },
      ],
      artist: { name: ARTIST_DEMO_ARTIST.name, artist_id: ARTIST_DEMO_ARTIST.artistId },
    };
  }

  const cancelled = scenarioId === 'exception';
  const billed = scenarioId === 'billing';
  const summerEvent = enrichDemoEventDetail(findDemoEvent('demo-event-summer-concert'));
  return {
    contract: {
      ...DEMO_CONTRACT_TERMS,
      event_uuid: 'demo-event-summer-concert',
      event_venue: 'キャスティカート文化ホール',
      reward_scheme: 'fixed',
      billing_open_reason: '',
      contract_type: 'performance_contract',
      request_memo: 'デモ公演の出演契約です。当日の進行は香盤表（ノート）をご確認ください。',
      is_multi: false,
      contact_person: '制作担当 佐藤',
    },
    contractArtist: {
      contract_artist_id: 'demo-contract-artist-yumiko',
      status: cancelled ? 'cancelled' : 'agreed',
      fee: 55000,
      payment_item_label: '出演料',
      withholding_required: true,
      event_cancel_amount: null,
      event_end_reported_at: billed ? '2026-06-20T22:00:00+09:00' : null,
      invoice_confirmed: false,
      invoice_resubmission_requested: cancelled,
      supplemental_invoices: [],
      additional_rewards: [],
      invoice_registered_at_contract: true,
      artist_name: ARTIST_DEMO_ARTIST.name,
    },
    event: summerEvent,
    events: [summerEvent],
    schedule: [
      { id: 'demo-sched-main', event_uuid: 'demo-event-summer-concert', schedule_date: '2026-07-04', start_time: '19:00', end_time: '', note: '本番', place_name: 'キャスティカート文化ホール', place_address: '東京都渋谷区' },
      { id: 'demo-sched-rehearsal', event_uuid: 'demo-event-summer-concert', schedule_date: '2026-07-03', start_time: '15:00', end_time: '18:00', note: 'ゲネプロ（通し稽古）', place_name: 'キャスティカート文化ホール', place_address: '東京都渋谷区' },
    ],
    artist: { name: ARTIST_DEMO_ARTIST.name, artist_id: ARTIST_DEMO_ARTIST.artistId },
  };
}

// GET /api/common/contract-change-logs/:contractArtistId
function demoContractChangeLogs(contractArtistId) {
  if (String(contractArtistId).includes('family')) return [];
  return [
    { id: 'demo-contract-log-1', created_at: '2026-06-26T11:00:00+09:00', change_details: '本契約が締結されました。' },
    { id: 'demo-contract-log-2', created_at: '2026-06-27T10:00:00+09:00', change_details: 'スケジュールが更新されました。' },
  ];
}

// GET /api/venues/:venueId （会場詳細。イベント詳細ページの会場リンク遷移先）
// ArtistVenueDetail は prefecture+city+address を連結して住所を表示するため、address には
// 都道府県・市区を除いた番地部分のみを持たせ、連結結果が正規の住所文字列になるようにする。
const DEMO_VENUE_DETAILS = Object.freeze({
  'demo-venue-hall': {
    id: 'demo-venue-hall',
    name: 'キャスティカート文化ホール',
    prefecture: '東京都',
    city: '渋谷区',
    address: '神南1-2-3',
    postal_code: '1500041',
    capacity: 800,
    phone: '03-1234-5678',
    website_link: 'https://example.com/casticart-culture-hall',
    google_map_link: '',
    venue_genre_names: ['コンサートホール'],
    access: 'JR渋谷駅から徒歩7分',
  },
  'demo-venue-bayside': {
    id: 'demo-venue-bayside',
    name: 'ベイサイドホテル横浜',
    prefecture: '神奈川県',
    city: '横浜市西区',
    address: '',
    capacity: 200,
  },
  'demo-venue-civic': {
    id: 'demo-venue-civic',
    name: 'さいたま市民音楽ホール',
    prefecture: '埼玉県',
    city: 'さいたま市浦和区',
    address: '高砂3-1-4',
    postal_code: '3300063',
    capacity: 600,
    phone: '048-555-0180',
    website_link: 'https://example.com/saitama-civic-music-hall',
    google_map_link: '',
    venue_genre_names: ['コンサートホール', '多目的ホール'],
    access: 'JR浦和駅西口から徒歩12分',
  },
  'demo-venue-garden': {
    id: 'demo-venue-garden',
    name: 'みどり野ガーデンホール',
    prefecture: '東京都',
    city: '立川市',
    address: '',
    capacity: 400,
  },
});

function demoVenueDetail(venueId) {
  return DEMO_VENUE_DETAILS[venueId] || null;
}

// GET /api/artist/manuals （+ /:slug 詳細）。出演者向けヘルプ記事（シナリオ非依存）。
const DEMO_MANUALS = Object.freeze([
  {
    id: 'demo-manual-getting-started',
    slug: 'demo-manual-getting-started',
    category: 'はじめに',
    title: 'Casticartでできること',
    sort_order: 1,
    updated_at: '2026-06-05T10:00:00+09:00',
    content_html: '<p>Casticartの出演者画面では、出演オファーの確認・回答、本契約の締結、事務局とのチャット、公演後の報酬請求までを一つの画面で管理できます。</p><p>ダッシュボードには今後の公演や対応が必要な項目がまとまって表示されます。まずは各メニューを開いて、全体の流れを確認してみましょう。</p>',
  },
  {
    id: 'demo-manual-offer',
    slug: 'demo-manual-offer',
    category: 'オファー',
    title: 'オファーに回答する',
    sort_order: 2,
    updated_at: '2026-06-08T10:00:00+09:00',
    content_html: '<p>受け取ったオファーは、詳細画面から「承諾・相談・辞退」を選んで回答できます。日程や報酬、会場などの条件を確認したうえでお選びください。</p><p>各オファーには回答期限が設定されています。期限を過ぎると自動的に無効となる場合がありますので、早めのご回答をおすすめします。</p>',
  },
  {
    id: 'demo-manual-contract',
    slug: 'demo-manual-contract',
    category: '本契約',
    title: '本契約を確認・締結する',
    sort_order: 3,
    updated_at: '2026-06-10T10:00:00+09:00',
    content_html: '<p>オファーを承諾すると本契約に進みます。報酬とスケジュールの内容を確認のうえ、締結してください。</p><p>締結後の公演やリハーサルの予定はカレンダーに自動で表示されます。変更があった場合は変更履歴からいつでも確認できます。</p>',
  },
  {
    id: 'demo-manual-chat',
    slug: 'demo-manual-chat',
    category: 'チャット',
    title: 'チャットの使い方',
    sort_order: 4,
    updated_at: '2026-06-12T10:00:00+09:00',
    content_html: '<p>タクティカートとの個別チャット、公演ごとのグループチャット、イベントチャットが利用できます。用途に応じて使い分けてください。</p><p>メッセージ内で「@」を入力すると担当者を指定してメンションできます。相手に通知が届くので、確実に伝えたい連絡に便利です。</p>',
  },
  {
    id: 'demo-manual-invoice',
    slug: 'demo-manual-invoice',
    category: '報酬・請求',
    title: '請求書を作成する',
    sort_order: 5,
    updated_at: '2026-06-15T10:00:00+09:00',
    content_html: '<p>公演が終了すると、経理・報酬画面から請求書を作成・送付できます。報酬額や源泉徴収の要否は契約内容に基づいて自動で反映されます。</p><p>追加の演奏やオプションが発生した場合は、追加請求として登録できます。支払予定日は画面上でご確認いただけます。</p>',
  },
  {
    id: 'demo-manual-profile',
    slug: 'demo-manual-profile',
    category: 'プロフィール',
    title: 'プロフィールを充実させる',
    sort_order: 6,
    updated_at: '2026-06-18T10:00:00+09:00',
    content_html: '<p>プロフィール画面では、写真や経歴、活動地域、演奏パートなどを登録できます。内容が充実しているほど、事務局からのオファーにつながりやすくなります。</p><p>登録した写真や経歴は、イベントの公開ページやフライヤーに掲載されることがあります。掲載可否の設定もあわせてご確認ください。</p>',
  },
]);

function jsonResponse(body, status = 200) {
  return new Response(JSON.stringify(body), {
    status,
    headers: { 'Content-Type': 'application/json; charset=utf-8', 'X-Casticart-Demo': 'artist' },
  });
}

function urlOf(input) {
  const raw = typeof input === 'string' ? input : input?.url || '';
  try {
    return new URL(raw, typeof window === 'undefined' ? 'http://localhost' : window.location.origin);
  } catch {
    return new URL('http://localhost/');
  }
}

function parseDemoJsonBody(body) {
  if (body && typeof body === 'object') return body;
  try {
    return JSON.parse(String(body || '{}'));
  } catch {
    return {};
  }
}

function demoUnicodeLength(value) {
  return Array.from(String(value || '')).length;
}

function fitDemoProfileText(value, maxChars) {
  const normalized = String(value || '')
    .replace(/\r\n?/g, '\n')
    .trim()
    .replace(/[ \t]+/g, ' ');
  const chars = Array.from(normalized);
  return chars.length <= maxChars
    ? normalized
    : `${chars.slice(0, Math.max(1, maxChars - 1)).join('')}…`;
}

function demoProfileSourceHash(sourceBio, generationGuidance) {
  const value = `${sourceBio}\u0000${generationGuidance}`;
  let hash = 2166136261;
  Array.from(value).forEach((char) => {
    hash ^= char.codePointAt(0) || 0;
    hash = Math.imul(hash, 16777619) >>> 0;
  });
  return hash.toString(16).padStart(8, '0').repeat(8);
}

function resolveDemoProfileAiGeneration(body) {
  const sourceBio = String(body?.sourceBio || '').replace(/\r\n?/g, '\n').trim();
  const guidance = String(body?.generationGuidance || '').replace(/\r\n?/g, '\n').trim();
  const sourceLength = demoUnicodeLength(sourceBio);
  if (!sourceBio) {
    return jsonResponse({
      success: false,
      code: 'ARTIST_PROFILE_AI_SOURCE_REQUIRED',
      message: 'メイン紹介プロフィールを入力してください。',
    }, 422);
  }
  if (sourceLength < DEMO_PROFILE_AI_LIMITS.sourceBioMinChars) {
    return jsonResponse({
      success: false,
      code: 'ARTIST_PROFILE_AI_SOURCE_TOO_SHORT',
      message: `メイン紹介プロフィールは${DEMO_PROFILE_AI_LIMITS.sourceBioMinChars}文字以上入力してください。`,
    }, 422);
  }
  if (sourceLength > DEMO_PROFILE_AI_LIMITS.sourceBioMaxChars) {
    return jsonResponse({
      success: false,
      code: 'ARTIST_PROFILE_AI_SOURCE_TOO_LONG',
      message: `メイン紹介プロフィールは${DEMO_PROFILE_AI_LIMITS.sourceBioMaxChars}文字以内で入力してください。`,
    }, 422);
  }
  if (demoUnicodeLength(guidance) > DEMO_PROFILE_AI_LIMITS.generationGuidanceMaxChars) {
    return jsonResponse({
      success: false,
      code: 'ARTIST_PROFILE_AI_GUIDANCE_TOO_LONG',
      message: `修正したい点・残したい要素は${DEMO_PROFILE_AI_LIMITS.generationGuidanceMaxChars}文字以内で入力してください。`,
    }, 422);
  }

  return jsonResponse({
    success: true,
    demo: true,
    sourceHash: demoProfileSourceHash(sourceBio, guidance),
    cacheStatus: 'generated',
    limits: DEMO_PROFILE_AI_LIMITS,
    variants: {
      bio_small_group: fitDemoProfileText(sourceBio, DEMO_PROFILE_AI_LIMITS.bioSmallGroupMaxChars),
      bio_large_group: fitDemoProfileText(sourceBio, DEMO_PROFILE_AI_LIMITS.bioLargeGroupMaxChars),
    },
  });
}

export function resolveArtistDemoFetch(input, init = {}) {
  if (!state.active || typeof Response === 'undefined') return null;
  const requestUrl = urlOf(input);
  const path = requestUrl.pathname;
  if (!path.startsWith('/api/')) return null;
  if (path === '/api/session/admin' || path === '/api/csrf-token' || path.startsWith('/api/maintenance')) {
    return null;
  }

  const method = String(init?.method || input?.method || 'GET').toUpperCase();
  const scenarioId = state.scenarioId;
  const unread = scenarioId === 'action-required' ? 5 : scenarioId === 'empty' || scenarioId === 'new-user' ? 0 : 2;

  if (method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS') {
    if (path === '/api/artist/profile/ai-variants' && method === 'POST') {
      if (init?.body == null && typeof input?.clone === 'function') {
        return input.clone().json()
          .catch(() => ({}))
          .then((body) => resolveDemoProfileAiGeneration(body));
      }
      return resolveDemoProfileAiGeneration(parseDemoJsonBody(init?.body));
    }
    // 初回オンボーディングの進捗をデモ内で疑似的に進める（実データは更新しない）。
    if (path === '/api/artists/profile') onboardingProgress.done.profile_basic = true;
    else if (path === '/api/artists/profile-picture') onboardingProgress.done.profile_photo = true;
    else if (path === '/api/artist/bank-info') onboardingProgress.done.bank_info = true;
    else if (path === '/api/artist/photos') onboardingProgress.done.promo_photo = true;

    if (path === '/api/artist/onboarding/dismiss') {
      onboardingProgress.dismissed = true;
      return jsonResponse(demoOnboardingStatus(scenarioId));
    }
    if (path === '/api/artist/onboarding/refresh') {
      return jsonResponse(demoOnboardingStatus(scenarioId));
    }
    const answerMatch = path.match(/^\/api\/artist\/onboarding\/steps\/([^/]+)\/answer$/);
    if (answerMatch) {
      const stepKey = decodeURIComponent(answerMatch[1]);
      let answerValue = '';
      try {
        answerValue = JSON.parse(init?.body || '{}')?.answer || '';
      } catch {
        answerValue = '';
      }
      if (ONBOARDING_STEP_KEYS.includes(stepKey) && answerValue !== 'no') {
        onboardingProgress.done[stepKey] = true;
      }
      return jsonResponse(demoOnboardingStatus(scenarioId));
    }

    return jsonResponse({ success: true, demo: true, message: 'デモ内の操作のため、実データは更新されません。' });
  }

  if (path === '/api/session/artist' || path === '/api/artist/auth/session') return jsonResponse(getArtistDemoIdentity());
  if (path === '/api/artist/onboarding/status') return jsonResponse(demoOnboardingStatus(scenarioId));
  if (path === '/api/artist/profile/ai-variants/status') {
    return jsonResponse({ success: true, enabled: true, limits: DEMO_PROFILE_AI_LIMITS });
  }
  if (path === '/api/artist/profile/me' || path === '/api/artist/profile') return jsonResponse(demoProfile(scenarioId));
  if (path === '/api/parts') return jsonResponse(DEMO_PARTS.map((item) => ({ ...item })));
  if (path === '/api/group-tags') return jsonResponse(DEMO_GROUP_TAGS.map((item) => ({ ...item })));
  if (path === '/api/artist/email-change/status') {
    return jsonResponse({ success: true, email: ARTIST_DEMO_ARTIST.email, pending: null });
  }
  if (path === '/api/artist/email-available') return jsonResponse({ success: true, available: true });
  if (path === '/api/auth/google/artist/link') {
    return jsonResponse({
      success: true,
      linked: true,
      email: ARTIST_DEMO_ARTIST.email,
      emailVerified: true,
      linkedAt: '2026-06-01T01:00:00.000Z',
      linkedAtJst: '2026/06/01 10:00',
      lastLoginAt: '2026-07-01T02:30:00.000Z',
      lastLoginAtJst: '2026/07/01 11:30',
    });
  }
  if (path === '/api/artist/bank-info') return jsonResponse({
    success: true,
    bankInfo: scenarioId === 'new-user' ? {} : {
      bank_name: 'デモ銀行',
      bank_code: '0000',
      branch_name: 'デモ支店',
      branch_code: '001',
      account_type: '普通',
      account_number: '1234567',
      account_name: 'ガクダン ユミコ',
      invoice_registered: true,
      invoice_number: 'T1234567890123',
      invoice_company_name: '楽団 弓子',
      postal_code: '100-0001',
      address: '東京都千代田区千代田1-1',
    },
  });
  if (path === '/api/artist/photos') return jsonResponse({
    success: true,
    photos: scenarioId === 'new-user' ? [] : [{
      id: 'demo-photo-yumiko',
      filename: 'yumiko-gakudan-promo.jpg',
      url: demoAssetUrl(DEMO_PROMO_IMAGE_PATH),
      comment: '演奏会プロフィール・フライヤー掲載可（デモ画像）',
      uploaded_at: '2026-06-01T10:30:00+09:00',
    }],
  });
  if (path === '/api/artist/notification-pref') return jsonResponse({
    success: true,
    normalMessageFrequency: 'immediate',
    mobilePushEnabled: true,
    mobilePushPermission: 'granted',
    mobilePushCheckedAt: '2026-07-01T11:30:00+09:00',
    emailSuppressed: false,
  });
  if (path === '/api/artist/offer-count') return jsonResponse({ success: true, count: demoOffers(scenarioId).filter((item) => item.status === 'pending').length });
  if (path === '/api/artist/contract-count') return jsonResponse({ success: true, count: demoContracts(scenarioId).contracts.length });
  if (path === '/api/artist/hold-castings') return jsonResponse(demoOffers(scenarioId));
  if (path === '/api/artist/contracts' || path === '/api/artist/contracts/period') return jsonResponse(demoContracts(scenarioId));
  if (path === '/api/artist/events/filter-by-date' || path === '/api/artist/events/upcoming') {
    return jsonResponse({ success: true, events: filterDemoEvents(demoEvents(scenarioId), requestUrl.searchParams) });
  }
  if (path === '/api/artist/events/calendar-summary') {
    return jsonResponse({ success: true, events: filterDemoEvents(demoEvents(scenarioId), requestUrl.searchParams) });
  }

  // イベント詳細ページの任意サブセクション（香盤表 / 共有シーティング / 取り置き・招待）は、
  // 下の広いイベント詳細プレフィックス一致より前に判定する必要がある（同じ prefix に飲み込まれるため）。
  const sharedTimetableMatch = path.match(/^\/api\/events\/([^/]+)\/timetables\/shared$/);
  if (sharedTimetableMatch) {
    return jsonResponse({
      success: true,
      timetables: demoSharedTimetables(decodeURIComponent(sharedTimetableMatch[1])),
    });
  }
  if (/^\/api\/events\/[^/]+\/timetables\/\d+\/runtime$/.test(path)) {
    return jsonResponse({ adjustments: [], memos: [], announcements: [], permissions: { can_edit: false } });
  }
  const stageSeatingSharedMatch = path.match(/^\/api\/artist\/events\/([^/]+)\/stage-seating\/shared$/);
  if (stageSeatingSharedMatch) {
    return jsonResponse(demoSharedStageSeating(decodeURIComponent(stageSeatingSharedMatch[1])));
  }
  const guestTicketMatch = path.match(/^\/api\/artist\/events\/([^/]+)\/guest-tickets$/);
  if (guestTicketMatch) {
    return jsonResponse({
      success: true,
      dashboard: demoGuestTicketDashboard(decodeURIComponent(guestTicketMatch[1])),
    });
  }

  if (/^\/api\/(?:artist\/)?events\/demo-event-/.test(path)) {
    const eventId = path.split('/').find((part) => part.startsWith('demo-event-'));
    const baseEvent = demoEvents(scenarioId).find((item) => item.event_uuid === eventId)
      || demoEvents('standard').find((item) => item.event_uuid === eventId);
    // 「イベント情報」サブパネル（ジャンル/概要/プログラム/主催/出演者）が空にならないよう拡充する。
    const event = enrichDemoEventDetail(baseEvent);
    return jsonResponse(event ? { success: true, event, ...event } : { success: false, message: 'デモイベントが見つかりません。' }, event ? 200 : 404);
  }
  if (path === '/api/artist/timetables/active') return jsonResponse({ success: true, timetables: [] });
  if (path === '/api/artist/quick-tasks') return jsonResponse({ success: true, items: demoQuickTasks(scenarioId) });
  if (path === '/api/venuelist') return jsonResponse({ success: true, venues: [
    { id: 'demo-venue-hall', name: 'キャスティカート文化ホール', prefecture: '東京都', city: '渋谷区' },
    { id: 'demo-venue-bayside', name: 'ベイサイドホテル横浜', prefecture: '神奈川県', city: '横浜市' },
    { id: 'demo-venue-civic', name: 'さいたま市民音楽ホール', prefecture: '埼玉県', city: 'さいたま市' },
    { id: 'demo-venue-garden', name: 'みどり野ガーデンホール', prefecture: '東京都', city: '立川市' },
  ], total: 4, page: 1, limit: 100 });
  if (path === '/api/artist/messages/unread-count') return jsonResponse({ success: true, unreadCount: unread, count: unread });
  if (/^\/api\/artist\/messages\/\d+\/\d+$/.test(path)) {
    return jsonResponse({ success: true, messages: demoPersonalMessages(unread) });
  }
  if (path === '/api/artist/group-chat/unread-count') {
    const threads = demoGroupThreadsForList(scenarioId);
    const unreadCounts = threads.map((thread) => ({ thread_id: thread.thread_id, unread_count: thread.unread_count || 0 }));
    const total = unreadCounts.reduce((sum, item) => sum + item.unread_count, 0);
    return jsonResponse({ success: true, unreadCounts, unreadCount: total, totalUnreadCount: total, threads });
  }
  if (path === '/api/artist/group-chat/threads') {
    return jsonResponse({ success: true, threads: demoGroupThreadsForList(scenarioId) });
  }
  if (/^\/api\/artist\/group-chat\/threads\/[^/]+\/messages\/(?:around\/[^/]+\/\d+\/\d+|\d+\/\d+)$/.test(path)) {
    return jsonResponse({ success: true, messages: demoGroupMessages(scenarioId), hasMore: false, hasOlder: false, hasNewer: false, offset: 0 });
  }
  if (/^\/api\/artist\/group-chat\/threads\/[^/]+$/.test(path)) {
    const detail = demoGroupThreadDetail(scenarioId);
    return detail
      ? jsonResponse({ success: true, thread: detail })
      : jsonResponse({ success: false, message: 'デモグループが見つかりません。' }, 404);
  }

  // --- ドリルダウン詳細（オファー / 本契約 / 変更履歴 / 参加者）---
  const offerDetailMatch = path.match(/^\/api\/artist\/offer-details\/([^/]+)$/);
  if (offerDetailMatch) {
    return jsonResponse(demoOfferDetail(scenarioId, decodeURIComponent(offerDetailMatch[1])));
  }
  const contractDetailMatch = path.match(/^\/api\/artist\/contract-detail\/([^/]+)$/);
  if (contractDetailMatch) {
    return jsonResponse({
      success: true,
      data: demoContractDetail(scenarioId, decodeURIComponent(contractDetailMatch[1])),
    });
  }
  const contractChangeLogMatch = path.match(/^\/api\/common\/contract-change-logs\/([^/]+)$/);
  if (contractChangeLogMatch) {
    return jsonResponse({
      success: true,
      data: demoContractChangeLogs(decodeURIComponent(contractChangeLogMatch[1])),
    });
  }
  const castingInfoMatch = path.match(/^\/api\/common\/events\/([^/]+)\/casting-info$/);
  if (castingInfoMatch) {
    return jsonResponse(demoEventCastingInfo(decodeURIComponent(castingInfoMatch[1])));
  }
  const castingProgressMatch = path.match(/^\/api\/common\/events\/([^/]+)\/casting-progress$/);
  if (castingProgressMatch) {
    return jsonResponse(demoEventCastingProgress(decodeURIComponent(castingProgressMatch[1])));
  }

  const eventChatEvents = demoEvents(scenarioId);
  const eventChatEventById = (eventId) => eventChatEvents.find((event) => event.event_uuid === eventId)
    || demoEvents('standard').find((event) => event.event_uuid === eventId);
  const eventChatFlyerUrl = (eventId) => {
    const flyerPath = DEMO_FLYER_PATHS[eventId];
    return flyerPath ? demoAssetUrl(flyerPath) : '';
  };
  const eventChatPageMatch = path.match(/^\/api\/event-chat\/events\/([^/]+)\/messages\/(\d+)\/(\d+)$/);
  if (eventChatPageMatch) {
    const eventId = decodeURIComponent(eventChatPageMatch[1]);
    const offset = Math.max(0, Number(eventChatPageMatch[2]) || 0);
    const limit = Math.max(1, Number(eventChatPageMatch[3]) || 50);
    const allMessages = getArtistDemoEventChatMessages(
      scenarioId,
      eventChatEventById(eventId),
      eventChatFlyerUrl(eventId)
    );
    // 本番APIと同じくoffsetは最新側から数え、wire上は古い→新しい（ASC）で返す。
    const end = Math.max(0, allMessages.length - offset);
    const start = Math.max(0, end - limit);
    const messages = allMessages.slice(start, end);
    return jsonResponse({ success: true, messages, hasMore: start > 0 });
  }
  const eventChatAroundMatch = path.match(/^\/api\/event-chat\/events\/([^/]+)\/messages\/around\/([^/]+)\/(\d+)\/(\d+)$/);
  if (eventChatAroundMatch) {
    const eventId = decodeURIComponent(eventChatAroundMatch[1]);
    const messageId = decodeURIComponent(eventChatAroundMatch[2]);
    const before = Math.max(0, Number(eventChatAroundMatch[3]) || 0);
    const after = Math.max(0, Number(eventChatAroundMatch[4]) || 0);
    const allMessages = getArtistDemoEventChatMessages(
      scenarioId,
      eventChatEventById(eventId),
      eventChatFlyerUrl(eventId)
    );
    const anchorIndex = allMessages.findIndex((message) => message.id === messageId);
    if (anchorIndex < 0) return jsonResponse({ success: false, message: 'デモメッセージが見つかりません。' }, 404);
    const start = Math.max(0, anchorIndex - before);
    const end = Math.min(allMessages.length, anchorIndex + after + 1);
    return jsonResponse({
      success: true,
      messages: allMessages.slice(start, end),
      offset: allMessages.length - end,
      hasOlder: start > 0,
      hasNewer: end < allMessages.length,
    });
  }
  const eventChatBeforeMatch = path.match(/^\/api\/event-chat\/events\/([^/]+)\/messages\/before\/([^/]+)\/(\d+)$/);
  if (eventChatBeforeMatch) {
    const eventId = decodeURIComponent(eventChatBeforeMatch[1]);
    const beforeCreatedAt = decodeURIComponent(eventChatBeforeMatch[2]);
    const limit = Math.max(1, Number(eventChatBeforeMatch[3]) || 50);
    const older = getArtistDemoEventChatMessages(
      scenarioId,
      eventChatEventById(eventId),
      eventChatFlyerUrl(eventId)
    ).filter((message) => message.created_at < beforeCreatedAt);
    const messages = older.slice(Math.max(0, older.length - limit));
    return jsonResponse({ success: true, messages, hasMore: older.length > messages.length });
  }
  const eventChatNewMatch = path.match(/^\/api\/event-chat\/events\/([^/]+)\/messages\/new\/([^/]+)$/);
  if (eventChatNewMatch) {
    const eventId = decodeURIComponent(eventChatNewMatch[1]);
    const lastCreatedAt = decodeURIComponent(eventChatNewMatch[2]);
    const messages = getArtistDemoEventChatMessages(
      scenarioId,
      eventChatEventById(eventId),
      eventChatFlyerUrl(eventId)
    ).filter((message) => message.created_at > lastCreatedAt);
    return jsonResponse({ success: true, messages, hasMore: false });
  }
  if (path === '/api/event-chat/unread-counts/artist') {
    const unreadCounts = getArtistDemoEventChatUnreadCounts(scenarioId, eventChatEvents);
    const totalUnread = unreadCounts.reduce((sum, item) => sum + item.unread_count, 0);
    return jsonResponse({ success: true, unreadCounts, totalUnread, unreadCount: totalUnread });
  }
  if (path.includes('/event-chat/unread')) return jsonResponse({ success: true, unreadCount: unread, counts: {}, events: [] });
  if (path.includes('/event-chat/available-events')) {
    const events = decorateArtistDemoEventChatEvents(scenarioId, eventChatEvents, eventChatFlyerUrl);
    return jsonResponse({ success: true, events, hasMore: false });
  }
  if (path === '/api/announcements/feed') {
    const announcements = demoAnnouncements(scenarioId);
    return jsonResponse({ success: true, announcements, total: announcements.length, limit: 100, offset: 0 });
  }
  if (path === '/api/bug-reports/status') {
    return jsonResponse({
      success: true,
      bugReporting: {
        enabled: true,
        lastUpdatedAt: '2026-07-01T09:00:00+09:00',
        lastUpdatedBy: 'システム管理者',
      },
    });
  }
  if (path === '/api/bug-reports') {
    const bugReports = [{
      id: 'demo-bug-report-1',
      title: 'イベント詳細の表示について',
      body: '公演資料を開いたあとも、元のスクロール位置へ戻れると使いやすいです。',
      reporterRole: 'artist',
      reporterName: ARTIST_DEMO_ARTIST.name,
      isResolved: false,
      createdAt: '2026-06-28T14:20:00+09:00',
      resolvedAt: null,
    }];
    return jsonResponse({ success: true, bugReports, total: bugReports.length, limit: 100, offset: 0 });
  }
  if (path === '/api/genres') return jsonResponse(DEMO_GENRES.map((item) => ({ ...item })));
  if (path === '/api/venue-genres') {
    return jsonResponse({ genres: DEMO_VENUE_GENRES.map((item) => ({ ...item })) });
  }
  if (path === '/api/artist/concierge/dashboard') {
    return jsonResponse({
      applications: [{
        id: 'demo-concierge-application',
        eventTitle: '楽団 弓子 デビュー15周年リサイタル',
        plannedDate: '2026-11-21',
        startTime: '18:30',
        venue: '紀尾井アートホール',
        outline: '室内楽の仲間と届ける、デビュー15周年記念公演です。',
        status: 'approved',
        statusLabel: '承認',
        createdAt: '2026-06-18T10:15:00+09:00',
        additionalInfoToken: 'demo-concierge-token',
      }],
      pastConciergeEvents: [{
        id: 'demo-event-summer-concert',
        eventUuid: 'demo-event-summer-concert',
        name: 'Casticart デモコンサート',
        eventName: 'Casticart デモコンサート',
        eventDate: '2026-07-04',
        venue: 'キャスティカート文化ホール',
        flyerUrl: demoAssetUrl(DEMO_FLYER_PATHS['demo-event-summer-concert']),
        flyerFront: demoAssetUrl(DEMO_FLYER_PATHS['demo-event-summer-concert']),
      }],
    });
  }
  const conciergeApplicationMatch = path.match(/^\/api\/artist\/concierge\/applications\/by-token\/([^/]+)$/);
  if (conciergeApplicationMatch) {
    return jsonResponse({
      application: {
        id: 'demo-concierge-application',
        event_title: '楽団 弓子 デビュー15周年リサイタル',
        planned_date: '2026-11-21',
        start_time: '18:30',
        venue: '紀尾井アートホール',
        outline: '室内楽の仲間と届ける、デビュー15周年記念公演です。',
        status: 'approved',
        token: decodeURIComponent(conciergeApplicationMatch[1]),
      },
    });
  }
  if (path.startsWith('/api/artist/concierge')) return jsonResponse({ success: true, applications: [], pastConciergeEvents: [] });
  if (path.startsWith('/api/artist/rewards/years')) {
    return jsonResponse(scenarioId === 'new-user' ? [] : [{ year: 2026, fee_total: 63800, payout_total: 63800, count: 2 }]);
  }
  if (path.startsWith('/api/artist/rewards')) return jsonResponse(demoRewards(scenarioId));

  const venueMaterialsMatch = path.match(/^\/api\/venues\/([^/]+)\/materials$/);
  if (venueMaterialsMatch) {
    return jsonResponse({
      success: true,
      materials: [{
        id: 'demo-venue-material-stage-plan',
        venue_id: decodeURIComponent(venueMaterialsMatch[1]),
        title: '舞台平面図・搬入口案内',
        file_name: 'demo-stage-plan.pdf',
        file_key: 'artist-demo/demo-stage-plan.pdf',
        mime_type: 'application/pdf',
        file_size: 842000,
        share_with_artists: true,
        created_at: '2026-06-01T10:00:00+09:00',
      }],
    });
  }

  // GET /api/venues/:venueId （イベント詳細ページの会場リンク遷移先）
  const venueDetailMatch = path.match(/^\/api\/venues\/([^/]+)$/);
  if (venueDetailMatch) {
    const venue = demoVenueDetail(decodeURIComponent(venueDetailMatch[1]));
    return venue
      ? jsonResponse({ success: true, venue })
      : jsonResponse({ success: false, message: 'デモ会場が見つかりません。' }, 404);
  }

  // GET /api/artist/manuals （一覧）と /api/artist/manuals/:slug （記事詳細）
  if (path === '/api/artist/manuals') {
    const manuals = DEMO_MANUALS.map(({ content_html, ...summary }) => summary);
    return jsonResponse({ success: true, manuals });
  }
  const manualDetailMatch = path.match(/^\/api\/artist\/manuals\/([^/]+)$/);
  if (manualDetailMatch) {
    const slug = decodeURIComponent(manualDetailMatch[1]);
    const manual = DEMO_MANUALS.find((item) => item.slug === slug) || null;
    return manual
      ? jsonResponse({ success: true, manual, images: [] })
      : jsonResponse({ success: false, message: 'デモマニュアルが見つかりません。' }, 404);
  }

  return jsonResponse({ success: true, demo: true, items: [], data: [], events: [], messages: [], threads: [] });
}
